import React, { useState, useEffect } from 'react'
import { FaTimes } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import api from '../api/api'

const NotificationModal = () => {
    const [modal, setModal] = useState(null)
    const [isOpen, setIsOpen] = useState(false)
    
    useEffect(() => {
        fetchModalNotification()
    }, [])
    
    const fetchModalNotification = async () => {
        try {
            const { data } = await api.get('/home/notifications/active', {
                params: { userType: 'all' }
            })
            
            // Filter only modal type
            const modalNotifications = data.notifications.filter(n => n.displayType === 'modal')
            
            if (modalNotifications.length > 0) {
                // Show highest priority modal
                const highestPriority = modalNotifications.sort((a, b) => {
                    const priorities = { urgent: 4, high: 3, medium: 2, low: 1 }
                    return (priorities[b.priority] || 0) - (priorities[a.priority] || 0)
                })[0]
                
                // Check if already dismissed
                const dismissedModals = JSON.parse(localStorage.getItem('dismissedModals') || '[]')
                
                if (!dismissedModals.includes(highestPriority._id)) {
                    setModal(highestPriority)
                    setIsOpen(true)
                    
                    // Track view
                    api.post(`/home/notifications/${highestPriority._id}/view`).catch(() => {})
                }
            }
            
        } catch (error) {
            console.error('Error:', error)
        }
    }
    
    const handleClose = () => {
        if (modal) {
            // Track dismiss
            api.post(`/home/notifications/${modal._id}/dismiss`).catch(() => {})
            
            // Save to localStorage
            const dismissedModals = JSON.parse(localStorage.getItem('dismissedModals') || '[]')
            dismissedModals.push(modal._id)
            localStorage.setItem('dismissedModals', JSON.stringify(dismissedModals))
        }
        
        setIsOpen(false)
    }
    
    const handleActionClick = () => {
        if (modal) {
            api.post(`/home/notifications/${modal._id}/click`).catch(() => {})
        }
        handleClose()
    }
    
    const getTypeColor = (type) => {
        const colors = {
            info: 'border-blue-500',
            warning: 'border-yellow-500',
            success: 'border-green-500',
            error: 'border-red-500',
            maintenance: 'border-purple-500'
        }
        return colors[type] || colors.info
    }
    
    const getButtonColor = (type) => {
        const colors = {
            info: 'bg-blue-500 hover:bg-blue-600',
            warning: 'bg-yellow-500 hover:bg-yellow-600',
            success: 'bg-green-500 hover:bg-green-600',
            error: 'bg-red-500 hover:bg-red-600',
            maintenance: 'bg-purple-500 hover:bg-purple-600'
        }
        return colors[type] || colors.info
    }
    
    if (!isOpen || !modal) return null
    
    return (
        <div className='fixed inset-0 bg-black/50 z-[10000] flex items-center justify-center p-4'>
            <div 
                className={`bg-white rounded-lg shadow-2xl max-w-md w-full border-t-4 ${getTypeColor(modal.type)} animate-modalSlideIn`}
            >
                {/* Header */}
                <div className='flex items-start justify-between p-6 border-b'>
                    <div className='flex items-center gap-3'>
                        <span className='text-4xl'>{modal.icon}</span>
                        <h3 className='text-xl font-bold text-gray-800'>
                            {modal.title}
                        </h3>
                    </div>
                    
                    {modal.isDismissible && (
                        <button
                            onClick={handleClose}
                            className='text-gray-400 hover:text-gray-600 p-1'
                        >
                            <FaTimes className='text-xl' />
                        </button>
                    )}
                </div>
                
                {/* Body */}
                <div className='p-6'>
                    <p className='text-gray-600 leading-relaxed'>
                        {modal.message}
                    </p>
                </div>
                
                {/* Footer */}
                <div className='p-6 border-t flex gap-3'>
                    {modal.actionLink && modal.actionText && (
                        <Link
                            to={modal.actionLink}
                            onClick={handleActionClick}
                            className={`flex-1 ${getButtonColor(modal.type)} text-white px-6 py-3 rounded-lg font-semibold text-center transition-colors`}
                        >
                            {modal.actionText}
                        </Link>
                    )}
                    
                    {modal.isDismissible && (
                        <button
                            onClick={handleClose}
                            className='flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold transition-colors'
                        >
                            Bağla
                        </button>
                    )}
                </div>
            </div>
            
            <style jsx>{`
                @keyframes modalSlideIn {
                    from {
                        transform: scale(0.9);
                        opacity: 0;
                    }
                    to {
                        transform: scale(1);
                        opacity: 1;
                    }
                }
                .animate-modalSlideIn {
                    animation: modalSlideIn 0.3s ease-out;
                }
            `}</style>
        </div>
    )
}

export default NotificationModal